(function () {
  document.addEventListener(
    'mouseenter',
    function (event) {
      const label = event.target.closest && event.target.closest('label[data-swatch-type="color"]');
      if (!label) return;
      const variantId = label.dataset.variantId;
      if (!variantId) return;

      document.dispatchEvent(
        new CustomEvent('variant:media-preview', {
          detail: { variantId: variantId },
        })
      );
    },
    true
  );

  document.addEventListener(
    'mouseleave',
    function (event) {
      const label = event.target.closest && event.target.closest('label[data-swatch-type="color"]');
      if (!label) return;

      document.dispatchEvent(new CustomEvent('variant:media-preview-end'));
    },
    true
  );
})();